import { hostQueryKeys as e } from "./useHostsQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { hostsApi as n } from "@maat/api-main";
//#region src/hosts/useHostListingsQuery.ts
var r = (r, i, a) => t({
	queryKey: e.listings(r, i, a),
	fetchPage: (e) => n.getHostListings(r, {
		page: e,
		areaId: i,
		city: a
	}),
	key: "listings"
});
//#endregion
export { r as useHostListingsQuery };
